module.exports = __webpack_public_path__ + "static/media/uj_szerzkot2.0baaf94f.jpg";